module.exports = __webpack_public_path__ + "img/图层 18.5683c7dd.png";